"use client";

import Image from "next/image";
import { Trans } from "react-i18next/TransWithoutContext";
import ClickPointer from "../../../../public/images/icons/clickPointer.svg?url";
import Kalarna from "../../../../public/images/icons/ico-klarna.svg?url";
import Truck from "../../../../public/images/icons/truck.svg?url";


const DesktopBlueHeader = ({ t }) => {
  return (
    <div className="row flex">
      <div className="col w-12/12 min-h-[24px] xs:block flex items-center">
        <div className="flex items-center justify-center xs:justify-between xs:max-w-[1100px] mx-auto blue-slider-wrapper">
          <div className="xs:w-auto w-12/12 flex items-center blue-slide xs:min-h-24 min-h-4">
            <div className="imageBox">
              <Image
                width={24}
                height={24}
                unoptimized
                alt="Truck"
                src={Truck}
                className="-mt-[2px]"
              />
            </div>
            <p className="text">
              <Trans t={t} i18nKey="usp.1">
                <span className="font-bold sm:me-[6px] ms-1 xs:ms-[10px] xs:me-2 me-1">
                  Free Delivery
                </span>
                <span className="flex">For orders above £25</span>
              </Trans>
            </p>
          </div>
          <div className="xs:w-auto w-12/12 flex items-center blue-slide xs:min-h-24 min-h-4">
            <div className="imageBox">
              <Image
                width={24}
                unoptimized
                alt="Kalarna"
                height="auto"
                src={Kalarna}
                className="-mt-[2px]"
              />
            </div>
            <p className="text">
              <Trans t={t} i18nKey="usp.2">
                <span className="font-bold sm:me-[6px] ms-1 sm:ms-[10px] xs:me-2 me-1">
                  Klarna
                </span>
                <span className="flex"> - Pay in 30 Days</span>
              </Trans>
            </p>
          </div>
          <div className="xs:w-auto w-12/12 flex items-center blue-slide xs:min-h-24 min-h-4">
            <div className="imageBox">
              <Image
                width={24}
                height={24}
                unoptimized
                alt="clickPointer"
                src={ClickPointer}
                className="-mt-[2px]"
              />
            </div>
            <p className="text">
              <Trans t={t} i18nKey="usp.3">
                <span className="font-bold sm:me-[6px] ms-1 xs:ms-[10px] xs:me-2 me-1">
                  Free Click & Collect
                </span>
                <span className="flex">For all orders</span>
              </Trans>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopBlueHeader;
